import { useTranslation } from 'react-i18next';

import type { DailyReportEntry } from '../../../api/types';
import styles from './TotalsSummary.module.css';

interface TotalsSummaryProps {
  daily: DailyReportEntry[];
}

type SizeKey = 'small' | 'medium' | 'big';

const SIZE_KEYS: SizeKey[] = ['small', 'medium', 'big'];

// PARA-105, AC-4: итоги — выполнено всего за период.
// PARA-122 (D10, AC-10): раскладка label-слева / число-справа (30px/600) +
// breakdown по размерам с цветными точками (образец reports/TotalsSummary.jsx).
export function TotalsSummary({ daily }: TotalsSummaryProps): JSX.Element {
  const { t } = useTranslation('reports');
  const total = daily.reduce((sum, entry) => sum + entry.completed, 0);
  const bySize: Record<SizeKey, number> = { small: 0, medium: 0, big: 0 };
  for (const entry of daily) {
    bySize.small += entry.by_size.small;
    bySize.medium += entry.by_size.medium;
    bySize.big += entry.by_size.big;
  }
  const breakdown = SIZE_KEYS.filter((size) => bySize[size] > 0);

  return (
    <div className={styles.card} data-testid="totals-summary">
      <div className={styles.head}>
        <span className={styles.label}>{t('totals.completed')}</span>
        <span className={styles.total}>{total}</span>
      </div>
      {breakdown.length > 0 && (
        <div className={styles.breakdown}>
          {breakdown.map((size) => (
            <span key={size} className={`${styles.item} ${styles[size]}`}>
              <span className={styles.dot} />
              {t(`totals.breakdown.${size}`, { count: bySize[size] })}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
